import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios"; // Import axios
import Navbar from "src/Component/Navbar";
import UniversityFinderBanner from "./components/UniversityFinderBanner";
import LetsGetStarted from "src/Component/LetsGetStarted";
import Footer from "src/Component/Footer";

const UniversityComparison = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const ids = searchParams.get("ids");
  const [universities, setUniversities] = useState([]);

  // Function to fetch comparison data from API
  const fetchComparisonData = async (ids) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}university/compareUniveristy`,
        { ids: ids.split(",") }, // Send array of university IDs
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setUniversities(response.data.data);
      } else {
        alert("Failed to retrieve comparison data.");
      }
    } catch (error) {
      console.error("Error fetching comparison data:", error);
    }
  };

  useEffect(() => {
    if (ids) {
      // Fetch comparison data
      fetchComparisonData(ids);
    }
  }, [ids]);

  return (
    <Box>
      <Navbar />
      <UniversityFinderBanner />
      <Box sx={{ padding: { xs: 2, md: 4 } }}>
        <Container>
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 2, mb: "40px" }}
          >
            <Button
              variant="contained"
              onClick={() => navigate(-1)}
              sx={{
                backgroundColor: "#00999E",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#007b8f",
                },
              }}
            >
              Back
            </Button>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "550",
                textAlign: { xs: "center", md: "left" },
              }} // Center text on small screens
              gutterBottom
            >
              Top University For You
            </Typography>
          </Box>
          <TableContainer
            component={Paper}
            sx={{ border: "2px solid #00999E" }}
          >
            <Table>
              <TableHead>
                <TableRow
                  sx={{ bgcolor: "#ffffff", borderBottom: "2px solid #00999E" }}
                >
                  <TableCell
                    sx={{
                      fontWeight: "600",
                      fontSize: "18px",
                      borderRight: "1px solid #00999E",
                    }}
                  >
                    University Name
                  </TableCell>
                  {universities.map((university) => (
                    <TableCell
                      key={university.universityId}
                      sx={{ borderRight: "1px solid #00999E" }}
                    >
                      <Box
                        sx={{
                          justifyContent: "center",
                          textAlign: "start",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Box>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: "600",
                              fontSize: "20px",
                              color: "#00999E",
                              textAlign: "center",
                            }}
                          >
                            {university.universityName}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {[
                  { label: "Country", key: "countryName" },
                  { label: "Intake", key: "Intake" },
                  { label: "Courses", key: "Courses" },
                  { label: "Tuition Fees", key: "TutionFee" },
                  { label: "Language", key: "Language" },
                  { label: "QS Ranking", key: "QSRanking" },
                  { label: "Duration", key: "Duration" },
                  { label: "URL", key: "URL" },
                ].map((detail, index) => (
                  <TableRow
                    key={detail.key}
                    sx={{
                      bgcolor: index % 2 === 0 ? "#effdff" : "#ffffff",
                      borderBottom:
                        detail.label === "QS Ranking"
                          ? ""
                          : "2px solid #00999E",
                    }}
                  >
                    <TableCell
                      sx={{
                        fontWeight: "600",
                        maxWidth: 250,
                        borderRight: "1px solid #00999E",
                      }}
                    >
                      {detail.label}
                    </TableCell>
                    {universities.map((university) => (
                      <TableCell
                        key={university.universityId}
                        sx={{
                          borderRight: "1px solid #00999E",
                          textAlign: "center",
                        }}
                      >
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: "550",
                              textAlign: "center",
                              maxWidth: 250,
                            }}
                          >
                            {Array.isArray(university[detail.key])
                              ? university[detail.key].join(", ") || "-"
                              : university[detail.key] || "-"}
                          </Typography>
                        </Box>
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Container>
      </Box>
      <LetsGetStarted marginTop={"50px"} />
      <Footer />
    </Box>
  );
};

export default UniversityComparison;
